import { CssBaseline } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LPAppBar from '../../app/components/LPAppBar';
import LPDrawer from '../../app/components/LPDrawer';
import { SizeMe } from '../../felles/useResizeObserver';
import Utils from '../../felles/Utils';
import MenuItemTarget from '../../models/MenuItemTarget';
import * as actions from '../../store/actions/index';
import { AppState } from '../../store/rootReducer';
import ACC1FormContent from './components/ACC1FormContent';


import { useStyles } from '../../assets/styles/DefaultPageStyle';

export default function ACC1Page(/*props*/) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const n: MenuItemTarget = useSelector((state) => (state as AppState).menuItem.menuItemTarget);
  //
  const handlePressedKey = (event: React.KeyboardEvent<HTMLDivElement>) => {

    const { key } = event;
    if ((event.shiftKey && key === 'End') || key === 'F3') {
      event.preventDefault();
      dispatch(actions.menuItemSetTarget(new MenuItemTarget(n.rootItem, n.item !== '' ? n.item : n.rootItem, '', '', n.tilpasset, n.prodSynlig
        , n.kodeSynlig, n.labelSynlig, n.menuSynlig, n.hasChildren, n.title)));
      dispatch(actions.menuItemSetSelected([n.rootItem, n.item + n.rootItem]));
      navigate(Utils.HOMEPAGE_CONTEXT + '/menu');
    }
  }
  //
  return (
    <div tabIndex={0} onKeyDown={(e) => handlePressedKey(e)}>
      <div className={classes.root}>
        <CssBaseline />
        <LPDrawer />
        <>
          <LPAppBar ismenuvisible={true} />
          <SizeMe>{({ size }) => <ACC1FormContent size={size} />}</SizeMe>
        </>
      </div >
    </div>
  );
}